/**
 * Head / Head PSO (sidebar + dashboard), excluding Regional Head.
 */
export function isPsoHeadDesignation(raw: string | undefined): boolean {
    const d = (raw || '').replace(/_/g, ' ');
    if (/regional/i.test(d)) return false;
    return /(^|\s)head(\s|$)/i.test(d);
}
